import {Component} from "react";
import myEmitter from "./my-events";
import demo from "../imgs/demo.jpg";
import {Radio} from "antd";
import connect from "react-redux/es/connect/connect";
import {bindActionCreators} from "redux";
import * as setAnswer from "../actions/evaluation";
import React from "react";
import {requestPost} from "../utils/Util";
const RadioGroup = Radio.Group;

class Reading extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: '',
        }

        this.answer = {
            index: '',
            value:''
        };
        const {answer,currentEvaluation} = props;
        const {answers} = answer;
        if(answers[currentEvaluation.page]){
            this.state.value = answers[currentEvaluation.page].value;
        }
    }


    _handlerNextQuestion = (action)=>{
        this._doSetAnswer(action);
    }

    async _setAnswer(page,A){
        const {match,answercurrentEvaluation,answer} = this.props;
        var params = {
            url: window.location.href.split('question/')[1].replace(/\//g,'_'),
            info: JSON.stringify({...answer.answers,[page]:A})
        }

        const answerSet = await requestPost(`/questionnaires/test_questions_save/`,'POST', params);
        console.log(params,answerSet);
    }

    _doSetAnswer(action) {
        // const {actions,currentEvaluation} = this.props;
        // this.answer.index = currentEvaluation.page;
        // this.answer.value = this.state.value;
        // console.log(action,actions)
        // this._setAnswer(currentEvaluation.page,{index:this.answer.index,value:this.answer.value});
        // actions.setAnswer(currentEvaluation.page, this.answer, this.answer);
    }

    componentWillUnmount() {
        myEmitter.off('nextQuestion', this._handlerNextQuestion);
        myEmitter.off('prevQuestion', this._handlerNextQuestion);
    }

    componentDidMount() {
        myEmitter.on('nextQuestion', this._handlerNextQuestion);
        myEmitter.on('prevQuestion', this._handlerNextQuestion);
    }


    onChange = (e) => {
        console.log('radio checked', e.target.value);
        this.setState({
            value: e.target.value,
        });
    }
    render() {
        const radioStyle = {
            display: 'block',
            minHeight: '30px',
        };
        const {answer,evaluation,currentEvaluation} = this.props;
        var correctAnswers = "";
        var h = evaluation.datas.length > 0 ? Object.values(Object.values(evaluation.datas[currentEvaluation.page])[0])[0] : '';
        return (
            <div className='questionItem'>
                <div className='content content_reading'>
                    <div dangerouslySetInnerHTML={{__html: h.passage}}/>
                </div>
                <div className='options'>
                    <p>题号：{h?h.number:""}</p>
                    <p  dangerouslySetInnerHTML={{__html: !h ? '' : h.description}} />
                    <div className='options_group'>
                        <RadioGroup value={this.state.value}>
                            {
                                h.options.map((item,index)=>{
                                    if(item.answer){
                                        correctAnswers += item.letter;
                                    }
                                    return <Radio style={radioStyle} value={item.id} checked={item.answer}><span style={{marginRight:10}}>{item.letter} </span>
                                        <span dangerouslySetInnerHTML={{__html: item.value}}/></Radio>
                                })
                            }
                        </RadioGroup>
                    </div>
                    <div className='analysisTitle' >解析：正确答案为 {correctAnswers}</div>
                    <div className='analysis'>
                        <p className='content' dangerouslySetInnerHTML={{__html: h.explanation}}/>
                    </div>
                </div>
            </div>
        );
    }
}
Reading = connect((state) => ({
    evaluation: state.evaluation,
    currentEvaluation: state.currentEvaluation,
    answer: state.answer,
}), (dispatch) => ({
    actions: bindActionCreators(setAnswer, dispatch),
}))( Reading);
export {Reading};
